<template>
  <div style="min-width:1000px;height:100%">
    <el-row style="height:100%;">
      <el-col :span="9" style="height:100%;">
        <div class="imger imger1" >
          <img src="./img/login/Logo@2x.png" class="logo">
          <label class="logo_span">江苏狄诺尼</label>
          <el-carousel indicator-position="outside" class="lbt" style="height:calc(100% - 100px);">
            <el-carousel-item v-for="(item,index) in lbt" :key="index" style="height:100%;">
              <img class="lbt_img" :src="item.imgUrl" />
              <div class="lbt_div">
                <label class="lbt_title">{{item.title}}</label></br>
                <div style="height:18px;"></div>
                <span class="lbt_span">{{item.text}}</span>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </el-col>
      <el-col :span="15" style="height: 100%">
        <div class="imger imger2">
          <a href="http://www.jsdnn.com/" target="_blank"><span  class="fwgw">访问官网 →</span></a>
          <el-card class="box-card logins" style="width:540px;height:700px;">
            <div class="login_div">
              <router-link to="/login"><span class="bak">←返回</span></router-link>
              <span class="login_span">申请试用</span>
              <el-form style="text-align:center;" :model="forgetForm" :rules="rules2" ref="forgetForm" >
                <el-form-item prop="name" class="register ">
                  <span class="iconfont icon-yonghu" style="font-size:16px;"></span>
                  <el-input class="phone_input"  style="height:48px;" v-model="forgetForm.name" auto-complete="off" placeholder="真实姓名" 
                    ></el-input>
                </el-form-item>
                <el-form-item prop="danwei" class="register password">
                  <span class="iconfont icon-danweiguanli" style="font-size:16px;"></span>
                  <el-input class="phone"  style="height:48px;" v-model="forgetForm.danwei" auto-complete="off" placeholder="单位名称" 
                    ></el-input>
                </el-form-item>
                <el-form-item prop="phone" class="register password">
                  <span class="iconfont icon-dianhua1" style="font-size:16px;"></span>
                  <el-input class="phone"  style="height:48px;" v-model="forgetForm.phone" auto-complete="off" placeholder="电话" 
                    ></el-input>
                </el-form-item>
                <el-form-item prop="QQ" class="register password">
                  <span class="iconfont icon-qq" style="font-size:16px;"></span>
                  <el-input class="phone" type='number' oninput="value=value.replace(/\D|^0/g,'')" v-model="forgetForm.QQ" placeholder="QQ"></el-input>
                </el-form-item>
                <el-form-item prop="zhiwei" class="register password">
                  <span class="iconfont icon-zhiwu" style="font-size:16px;"></span>
                  <el-input class="phone" v-model="forgetForm.zhiwei" auto-complete="off" placeholder="部门职务"></el-input>
                </el-form-item>
                <el-form-item prop="dizhi" class="register password">
                  <span class="iconfont icon-dizhi" style="font-size:16px;"></span>
                  <el-input class="phone"  v-model="forgetForm.dizhi" auto-complete="off" placeholder="联系地址"></el-input>
                </el-form-item>
                <!-- <el-form-item style="width:100%;margin-bottom:0px"> -->
                  <el-button type="danger" class="login_submit" @click.native.prevent="handleSubmit" 
                    data-appid="2014410046" data-cbfn="callback" 
                    :loading="logining">提交申请</el-button>
                <!-- </el-form-item> -->
              </el-form>
              <div class="tips">
                <router-link  :to="{path:'/login'}" >用户登录</router-link>
                <router-link  :to="{path:'/register'}" >免费注册</router-link>
              </div>
            </div>
          </el-card>
          <div class="span_bottom">
            <span style="line-height:30px;">
              江苏狄诺尼信息技术有限责任公司 
            </span></br>
            <span>
              CopyRight © 2019 Jiangsu Delauney Information Co., Ltd. <a href="https://beian.miit.gov.cn/" style="color: #666;" >苏ICP备18062906</a>
            </span>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script src="https://ssl.captcha.qq.com/TCaptcha.js"></script>
<script>
  import axios from 'axios'
  import { API__code, API__login } from '../api/index.js'
  export default {

    data() {
      return{
        logining: false,
        forgetForm: {
          name:'',
          danwei:'',
          phone: '',
          zhiwei:'',
          qq:'',
          dizhi:'',
        },
        rules2: {
          name: [
            { required: true, message: '请输入真实姓名', trigger: 'blur' },
          ],
          danwei: [
            { required: true, message: '请输入单位名称', trigger: 'blur' },
          ],
          phone: [
            { required: true, message: '请输入手机号', trigger: 'blur' },
          ],
          zhiwei: [
            { required: true, message: '请输入职务职位', trigger: 'blur' },
          ],
          dizhi: [
            { required: true, message: '请输入联系地址', trigger: 'blur' },
          ],
        },
        lbt:[
          {
            imgUrl:'./static/img/login/banner1@2x.png',
            title:'EICAD',
            text:'集成交互道路与立交系统 EICAD路线平面设计中，提供了智能化“路中线”实体。用户可以直接拖拽路中线上的各个夹点，以修改交点位置、圆曲线半径、缓和曲线长度、切线长和外距等设计参数，操作过程所见即所得。设计者可以忘记以往众多的设计功能命令，随心所欲地拖动调整，如同摆弄桌面上的一根绳索。'
          },
          {
            imgUrl:'./static/img/login/banner2@2x.png',
            title:'数字地面模型系统 EIDTM',
            text:'数字地面模型EIDTM模块是一个专门用于采集地形散点和等高线数据，构成三角网格，实现纵横断面剖切、地面高程坡度查询等数模应用的子系统。该模块旨在为道路工程设计者提供一套快捷、智能智能化、自动化的地形数字化及应用解决方案。软件能够在极短的时间内完成地形数字化、构网和实时剖切计算，极大的提高了数字化地形的应用效率。',
          },
          {
            imgUrl:'./static/img/login/banner3@2x.png',
            title:'BIM自动建模',
            text:'EIBIM软件提出了“线路信息模型”（Route Information Modeling）的基本实现架构，并实现了其技术途径。在EICAD模型成果的基础上，导出线路信息模型数据，利用Revit二次开发工具，实现道路信息模型的无缝转换、同步更新；并建立公路工程常用桥隧BIM构件库；开发桥隧工程的自动建模功能。EIBIM从根本上解决了上述难题。',
          }
        ],
      }
    },
    methods: {
      checkTencentCaptcha(ticket,randstr,appid){
        var ip = returnCitySN["cip"];
        let param = {
          Ticket:ticket,
          Randstr:randstr,
          UserIP:ip,
        }
        API__login.CheckTencentCaptcha(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.handleSubmit2();
          }
        });
      },
      handleSubmit(formName) {
        var _this = this;
        if(!this.forgetForm.name){
          this.$message.error('真实姓名不可为空，请输入姓名！');
          return;
        }
        if(!this.forgetForm.danwei){
          this.$message.error('单位不可为空！');
          return;
        }
        if(!this.forgetForm.phone){
          this.$message.error('电话不可为空，请输入电话号码！');
          return;
        }
        if(!this.forgetForm.zhiwei){
          this.$message.error('职务职位不可为空！');
          return;
        }
        if(!this.forgetForm.dizhi){
          this.$message.error('地址不可为空！');
          return;
        } 
        var captcha1 = new TencentCaptcha('2014410046', function(res) {
          if(res.ret === 0){
            _this.okSubmit();
          }
        });
        captcha1.show();
      },

      okSubmit(formName) {
        let _this = this;
        let param ={
          mode:'save',
          name:this.forgetForm.name,
          company:this.forgetForm.danwei,
          phone:this.forgetForm.phone,
          bumenzhiwei:this.forgetForm.zhiwei,
          adress:this.forgetForm.dizhi,
          qq:this.forgetForm.QQ,
        }
        API__login.addApplyOn(param)
        .then((res) =>{
          if(res.data.code == API__code.SUCCESS){
            this.$message({
              message: '提交成功',
              type: 'success'
            });
            _this.forgetForm = {};
          }else {
            this.$message.error(res.data.message);
          }
        }).catch(err =>{
          this.$message.error('服务器异常，请您稍后再试..');
        });
      },
    },
    mounted() {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src = 'https://ssl.captcha.qq.com/TCaptcha.js';
      document.body.appendChild(s);
    },
  }
</script>
<style lang="scss" scoped>
.fwgw{
  color:#F66B3D;
  font-size:16px;
  position:relative;
  float:right;
  right:60px;
  top:33px;
}
.lbt{
  position: relative;
  left: 50%;
  top:100px;
  -webkit-transform: translate(-50%,0);
  -ms-transform: translate(-50%,0);
  transform: translate(-50%,0);
}
.imger{
  height:100%;
  width: 100%;
  background-size: cover;
}
.imger1{    
  background:  url('./img/login/BG2@2x.png');
}
.imger2{  
  background:  url('./img/login/BG1@2x.png');
  background-size: 100%;
}
.logo{
  width: 32px;
  height: 32px;
  position: absolute;
  left: 42px;
  top: 32px;
}
.logo_span{
  font-size: 20px;
  font-weight: bold;
  color: #fff;
  position: absolute;
  left: 85px;
  top: 35px;
  font-family: "思源黑体 CN Bold Bold";
}
.logins{
  position: relative;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%,-50%);
  -ms-transform: translate(-50%,-50%);
  transform: translate(-50%,-50%);
}
.login_span{
  font-weight: bold;
  font-size: 24px;
  font-family: "思源黑体 CN Bold Bold";
  color:#F66B3D;
}
.login_div{
  text-align:center;
  position: relative;
  top:25px;
}
.register{
  width:400px;
  height: 40px;
  margin: 0 auto;
  font-size: 16px;
  position: relative;
  top: 45px;
}
.phone_input{
  width:400px;
  height: 60px;
  font-size: 16px;
}
.password{
  padding-top: 30px;
}
.login_submit{
  background-color:#F66B3D;width: 400px;
  background-color: rgb(246, 107, 61);
  height: 60px;
  position: relative;
  top: 90px;
  font-size: 20px;
  font-weight: Normal;
  font-family: "思源黑体 CN Bold Bold";
}
.tips {
    float: right;
    margin: 30px 50px 0 0;
    position: relative;
    top: 85px;
    font-size: 14px;
    color:#666666;
}
.tips a {
    color: #666;
    margin-left: 20px;
    cursor: pointer;
}

.lbt_img{
  width:500px;
  height:500px;
  clear: both; 
  display: block; 
  margin:auto; 
}
.lbt_div{
  text-align:center;
  width:82%;
  position:relative;
  left:9%;
}
.lbt_span{
  line-height: 24px;
  font-size: 14px;
  font-weight: normal;
  font-family: "思源黑体 CN Normal";
  color: #fff;
}
.lbt_title{
  line-height: 42px;
  font-size: 28px;
  font-weight: bold;
  font-family: "思源黑体 CN Normal";
  padding-bottom: 18px;
  color: #fff;
}
.span_bottom{
  text-align:center;
  bottom: 30px;
  position: absolute;
  font-size:14px;
  color:#666666;
  text-align: center;
  width: 62.5%;
}
.bak{
  color:#333333;
  font-size:16px;
  position: absolute;
  float: left;;
  left:35px;
  top:7px;
}


</style>


// WEBPACK FOOTER //
// ApplyOn.vue?5e3d5a59